import { createReducer } from "@reduxjs/toolkit";
import {
  RULES_LOADING,
  GET_RULES,
  RULES_ERROR,
  CREATE_RULES,
  EDIT_RULES,
  DELETE_RULES,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const rulesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(RULES_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(RULES_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(GET_RULES, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    })
    .addCase(CREATE_RULES, (state, { payload }) => {
      Array.isArray(state.data)
        ? state.data.push(payload)
        : (state.data = [payload]);
      state.loading = false;
    })
    .addCase(EDIT_RULES, (state, { payload }) => {
      const index = state.data.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
    })
    .addCase(DELETE_RULES, (state, { payload }) => {
      state.data = state.data.filter((e) => e?.id !== payload?.id);
      state.loading = false;
    });
});
export default rulesReducer;
